import Keycloak from 'keycloak-js';
import Cookies from 'js-cookie';
import TimeInMilliseconds from './common/time/TimeInMilliseconds';
import TimeInSeconds from './common/time/TimeInSeconds';

window.keycloakWrapper = ({
  clientId, realm, url,
}, baseUrl) => {
  const keycloak = new Keycloak({
    clientId,
    realm,
    url,
  });

  async function saveState() {
    const cookieToken = {
      accessToken: keycloak.token,
      refreshToken: keycloak.refreshToken,
    };
    await fetch(
      `${baseUrl}default/login-oauth/set-tokens`,
      { method: 'POST', body: JSON.stringify({ tokens: cookieToken }) },
    );
    localStorage.setItem('keycloak', JSON.stringify(keycloak));
  }
  return {
    async signin() {
      const loginInitOptions = {
        onLoad: 'login-required',
        checkLoginIframe: false,
      };
      await keycloak.init(loginInitOptions);
      await saveState();
      window.location.reload();
    },
    async checkSSO(redirectUri) {
      const keycloakInput = JSON.parse(localStorage.getItem('keycloak'));
      const loginInitOptions = {
        checkLoginIframe: false,
        token: keycloakInput.token,
        refreshToken: keycloakInput.refreshToken,
        idToken: keycloakInput.idToken,
      };
      try {
        await keycloak.init(loginInitOptions);
      } catch {
        // eslint-disable-next-line fp/no-this
        await this.signout(redirectUri);
        return;
      }
      setInterval(async () => {
        try {
          const tokenHasRefreshed = await keycloak.updateToken(TimeInSeconds.FIVE_MINUTES);
          if (tokenHasRefreshed) {
            await saveState();
          }
        } catch {
          // eslint-disable-next-line fp/no-this
          await this.signout(redirectUri);
        }
      }, TimeInMilliseconds.MINUTE * 5);
    },
    async signout(redirectUri) {
      Cookies.remove('tokens');
      localStorage.removeItem('keycloak');
      try {
        await keycloak.logout({ redirectUri, id_token_hint: keycloak.idToken });
      } catch {
        window.location.href = redirectUri;
      }
    },
  };
};
